/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';

export const EVENT_SUBSCRIPTION_ORIGIN_CLOUDFLARE = `Cloudflare`;
export const EVENT_SUBSCRIPTION_ORIGIN_SOLUTION_AUTH = `SolutionAuth`;
export const EVENT_SUBSCRIPTION_ORIGIN_CLIENT_LAYER = `custom`;
export const EVENT_SUBSCRIPTION_ORIGIN_SALESFORCE = `SalesForce`;
export const EVENT_SUBSCRIPTION_ORIGIN_FORM_ANSWER = `FormAnswer`;

export const EVENT_RULE_TYPE_REQUEST = `page.request`;
export const EVENT_RULE_TYPE_LOGIN = `solutionAuth.login`;
export const EVENT_RULE_TYPE_VISIT = `visit`;
export const EVENT_RULE_TYPE_CONSENT = `cdp.consent`;
export const EVENT_RULE_TYPE_CUSTOM = `custom`;

export const EVENT_RULE_LOGIC_OPERATOR_AND = `AND`;
export const EVENT_RULE_LOGIC_OPERATOR_OR = `OR`;

/**
 * Event subscription origin type.
 */
export type EventSubscriptionOrigin =
  | typeof EVENT_SUBSCRIPTION_ORIGIN_CLOUDFLARE
  | typeof EVENT_SUBSCRIPTION_ORIGIN_SOLUTION_AUTH
  | typeof EVENT_SUBSCRIPTION_ORIGIN_CLIENT_LAYER
  | typeof EVENT_SUBSCRIPTION_ORIGIN_SALESFORCE
  | typeof EVENT_SUBSCRIPTION_ORIGIN_FORM_ANSWER;

const EventRuleSubscriptionPropertyValue = io.type({
  attribute: io.string,
  comparison: io.string,
  value: io.unknown,
});

export type EventRuleSubscriptionPropertyValue = io.TypeOf<typeof EventRuleSubscriptionPropertyValue>;

const EventRuleSubscriptionRelevanceType = io.type({
  type: io.union([
    io.literal(`date`),
    io.literal(`months`),
    io.literal(`weeks`),
    io.literal(`days`),
    io.literal(`hours`),
    io.literal(`minutes`),
    io.literal(`seconds`),
  ]),
  value: io.union([io.string, io.number]),
});

/**
 * The segmentation event subscription entity type.
 */
export type EntitySegmentEventSubscription = io.TypeOf<typeof SegmentEventSubscription>;

/**
 * The segmentation event subscription entity definition.
 * @export
 */
export const SegmentEventSubscription = io.type(
  {
    attributeid: io.string,
    name: io.string,
    operator: io.union([io.literal(EVENT_RULE_LOGIC_OPERATOR_AND), io.literal(EVENT_RULE_LOGIC_OPERATOR_OR)]),
    origin: io.string,
    property: io.array(EventRuleSubscriptionPropertyValue),
    relevance: io.union([EventRuleSubscriptionRelevanceType, io.null]),
    type: io.union([
      io.literal(EVENT_RULE_TYPE_REQUEST),
      io.literal(EVENT_RULE_TYPE_LOGIN),
      io.literal(EVENT_RULE_TYPE_VISIT),
      io.literal(EVENT_RULE_TYPE_CUSTOM),
    ]),
    uniqueCustomId: io.union([io.string, io.null]),
  },
  `SegmentEventSubscription`,
);
